const listaDeProcessos = (state) => {
    return state.items;
}

const listaDeProcessosHierarquias = (state) => {
    return state.processosHierarquias;
}

const listaDeTiposAgings = (state) => {
    return state.tipoAgings;
}

const listaDeMacroProcessos = (state) => {
    return state.macroProcessos;
}

const loadingProcessos = (state) => {
    return state.carregando
}

export {
    listaDeProcessos,
    listaDeTiposAgings,
    listaDeMacroProcessos,
    listaDeProcessosHierarquias,
    loadingProcessos
}